import React from 'react';
import { Crown } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { todayPrice, totalValue } from '../data/valueStack';
export function CloseSection() {
  return <section className="cv-section relative w-full overflow-hidden border-t border-white/[0.06] bg-ink-950 py-16 sm:py-24 md:py-32" data-id="element-19" data-mp="2zhjuy0vutrmq">
      <div className="spot-beam pointer-events-none absolute -top-16 left-1/2 hidden h-[560px] w-[520px] -translate-x-1/2 animate-beam-flicker sm:block" aria-hidden="true" data-id="element-20" data-mp="34jsoozgjwxpw" />
      <div className="stage-vignette pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-21" data-mp="2uktgtj3m163y" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center px-5 text-center sm:px-6" data-id="element-22" data-mp="2gtycmk423d6p">
        <Reveal data-id="element-23" data-mp="2krmb1x4yjo3c">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold-400/45 bg-gold-400/[0.08] px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold-300" data-id="element-24" data-mp="26txq6paw4gya">
            <Crown className="h-3.5 w-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-25" data-mp="2buv5mu4imww3" />
            El último llamado a la inteligencia
          </span>
        </Reveal>

        <Reveal delay={0.05} data-id="element-26" data-mp="3ox4w7c7w6ti6">
          <h2 className="mt-5 text-balance text-[26px] font-extrabold leading-[1.12] tracking-tight text-[#f5f3ee] sm:mt-6 sm:text-4xl md:text-[46px]" data-id="element-27" data-mp="3p0952mwaydf6">
            Está a un clic del <span className="gold-text" data-id="element-28" data-mp="1tq92thh90og">1%</span> que no es víctima del sistema de
            salud cosmética.
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-29" data-mp="367f2ytjs2fsd">
          <p className="mt-4 max-w-xl text-[14px] leading-relaxed text-[#a7adb8] sm:mt-6 sm:text-[15px]" data-id="element-30" data-mp="36881j78l1yzf">
            Puede seguir siendo el cliente que paga el mármol de la clínica, o puede ser el dueño de
            su protocolo. La diferencia son ${todayPrice} y un poco de criterio. Si no toma esto
            ahora, acepte con dignidad que prefiere la comodidad de ser engañado al esfuerzo de estar
            optimizado.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-8 flex w-full flex-col items-center gap-2.5 sm:mt-10 sm:gap-3" data-id="element-31" data-mp="qgay1vapye98">
          <CtaButton size="lg" label={`Sí, soy lo suficientemente inteligente — acceso inmediato por $${todayPrice}`} data-id="element-32" data-mp="vfe15a752aek" />
          <div className="flex items-baseline gap-2.5 font-mono" data-id="element-33" data-mp="106mcwcvxy7uw">
            <span className="text-[11px] text-[#7c8494] line-through" data-id="element-34" data-mp="155gu5ae9focw">
              ${totalValue.toLocaleString('en-US')} valor total
            </span>
            <span className="text-[11px] text-[#6f7684]" aria-hidden="true" data-id="element-35" data-mp="7jjle4pomxe5">
              →
            </span>
            <span className="text-[17px] font-bold text-gold-300" data-id="element-36" data-mp="hfmj8ydi49va">
              ${todayPrice}
              <span className="ml-1 text-[11px] font-normal text-ash" data-id="element-37" data-mp="hhz9rzxbrsjy">hoy</span>
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}